import classNames from 'classnames';
import React from 'react';

type buttonVariants = 'primary' | 'secondary' | 'ghost' | 'danger';

export default function Button({
	children,
	variant = 'primary',
	leftIcon,
	rightIcon,
	className,
	...props
}: {
	children: React.ReactNode;
	variant?: buttonVariants;
	leftIcon?: React.ReactNode;
	rightIcon?: React.ReactNode;
	className?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>) {
	return (
		<button
			className={classNames(
				className,
				'flex h-full w-full items-center justify-center whitespace-nowrap rounded border px-2 py-1 font-medium xl:px-4',
				{
					'border-orange bg-orange text-dark shadow-md hover:bg-yellow-300':
						variant === 'primary',
					'border-orange text-orange hover:bg-gray-800':
						variant === 'secondary',
					'border-dm-red bg-transparent text-dm-red hover:border-transparent hover:bg-orange hover:text-dm-black':
				// 'h-full w-full flex justify-center items-center px-2 xl:px-4 py-1 rounded border whitespace-nowrap font-medium',
				// {
				// 	'shadow-md hover:bg-yellow-300 bg-orange text-dark border-orange':
				// 		variant === 'primary',
				// 	'hover:bg-gray-800 text-orange border-orange':
				// 		variant === 'secondary',
				// 	'border-dm-red bg-transparent text-dm-red hover:bg-orange hover:text-dm-black hover:border-transparent':
						variant === 'danger',
					'border-transparent bg-transparent text-orange hover:bg-orange hover:text-dm-black':
						variant === 'ghost',

					'cursor-not-allowed opacity-80': props.disabled
				}
			)}
			{...props}
		>
			{leftIcon && <span className="mr-2">{leftIcon}</span>}
			{children}
			{rightIcon && <span className="ml-2">{rightIcon}</span>}
			{/*  {leftIcon && <span className="mr-[6px]">{leftIcon}</span>}
			 {children}
			 {rightIcon && <span className="ml-[6px]">{rightIcon}</span>} */}
		</button>
	);
}
